package com.gsb.vyapar.bhagya.presentation.admin.view

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.admin.util.saveConfigButton
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.edittext.VersionEditText
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.util.getString

@Composable
fun ConfigView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    var info by remember { mutableStateOf("") }
    var category by remember { mutableStateOf("") }
    var subCategory by remember { mutableStateOf("") }
    var business by remember { mutableStateOf("") }
    LaunchedEffect(Unit) {
        val config = uiState.getConfig()
        info = config.d.config[INFO].getString()
        category = config.d.config[CATEGORY].getString()
        subCategory = config.d.config[SUBCATEGORY].getString()
        business = config.d.config[BUSINESS].getString()
    }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar("Config")
            Column(Modifier.verticalScroll(rememberScrollState()).padding(horizontal = 16.dp)) {
                Spacer(Modifier.height(8.dp))
                VersionEditText("Enter Info Version", info) { info = it }
                Spacer(Modifier.height(8.dp))
                VersionEditText("Enter Category Version", category) { category = it }
                Spacer(Modifier.height(8.dp))
                VersionEditText("Enter SubCategory Version", subCategory) { subCategory = it }
                Spacer(Modifier.height(8.dp))
                VersionEditText("Enter last business number", business) { business = it }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Save Config") {
                    saveConfigButton(info, category, subCategory, business)
                }
                Spacer(Modifier.height(8.dp))
            }
        }
    }
}